
import React from "react";
import user from "../../assets/users/user.png";
import { FiStar } from "react-icons/fi"; 

const ServiceForm = () => {
  return (
    <div className="border border-brand-primary flex  flex-col lg:flex-row justify-between w-full md:py-20 md:px-10 rounded-xl items-stretch">
      {/* Left Column */}
      <div className="w-full lg:w-1/2 p-4 flex flex-col items-center lg:items-start justify-between">
        <div className="mb-8 text-center w-full md:w-1/2 lg:text-left">
          <h2 className="text-2xl text-center  lg:text-left font-bold">Bricksnmix</h2>
          <p className="mt-3 text-gray-600">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde neque
            necessitatibus voluptatem.
          </p>
        </div>

        {/* User Reviews Section */}
        <div className="flex flex-col items-center w-full lg:w-1/2 max-w-sm text-center">
          <div className="flex justify-start flex-col items-center lg:flex-row lg:items-start w-full gap-4 mb-2">
            <img src={user} alt="User" className="w-16 h-16 rounded-full" />
            <div className="mb-1 lg:mt-2 text-center lg:text-left">
              <h3 className="text-lg font-semibold">Lidiya</h3>
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <FiStar key={i} className="text-yellow-500 fill-yellow-500 w-5 h-5" />
                ))}
              </div>
            </div>
          </div>
          <p className="text-sm text-left">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam.
          </p>
        </div>
      </div>

      {/* Right Column  Form Section */}
      <div className="w-full lg:w-1/2 p-4 mt-5 md:mt-0">
        <form>
          <div className="flex flex-col gap-6">
            <div className="flex flex-col">
              <label htmlFor="first-name" className="mb-2 font-medium">
                First Name
              </label>
              <input
                type="text"
                id="first-name"
                className="border border-gray-200 p-3 rounded focus:outline-none focus:ring-1 focus:ring-gray-300"
                required
              />
            </div>
            <div className="flex flex-col md:flex-row justify-between w-full gap-5">
              <div className="flex flex-col w-full md:w-1/2">
                <label htmlFor="email" className="mb-2 font-medium">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  className="border border-gray-200  p-3 rounded focus:outline-none focus:ring-1 focus:ring-gray-300"
                  required
                />
              </div>
              <div className="flex flex-col w-full md:w-1/2">
                <label htmlFor="phone" className="mb-2 font-medium">
                  Phone Number
                </label>
                <input
                  type="text"
                  id="phone"
                  className="border border-gray-200 p-3 rounded focus:outline-none focus:ring-1 focus:ring-gray-300"
                  required
                />
              </div>
            </div>
            <div className="flex flex-col">
              <label htmlFor="product-review" className="mb-2 font-medium">
                Product Review
              </label>
              <input
                type="text"
                id="product-review"
                className="border border-gray-200 p-3 rounded focus:outline-none focus:ring-1 focus:ring-gray-300"
                required
              />
            </div>
            <div className="flex flex-col">
              <label htmlFor="message" className="mb-2 font-medium">
                Message
              </label>
              <textarea
                id="message"
                className="border border-gray-200 p-3 rounded focus:outline-none focus:ring-1 focus:ring-gray-300 h-56"
                required
              />
            </div>
            <div className="flex items-center mt-4">
              <input
                type="checkbox"
                id="terms"
                className="mr-2 cursor-pointer"
              />
              <label htmlFor="terms" className="text-gray-700 cursor-pointer">
                I accept the Terms
              </label>
            </div>
          </div>

          <button
            type="submit"
            className="my-10 text-brand-primary border border-brand-primary w-full p-4 rounded hover:bg-brand-primary hover:text-white transition duration-300"
          >
            SUBMIT
          </button>
        </form>
      </div>
    </div>
  );
};

export default ServiceForm;
